import styled from 'styled-components'

import Container from '../../components/layout/Container'
import { Section as BaseSection } from '../listing/Sections/shared'

export const Section = styled(BaseSection)`
  padding: 60px 0;
`

export const NarrowerContainer = styled(Container)`
  max-width: 900px;
  overflow: hidden;
`
